import { render, staticRenderFns } from "./ServiceIndex.vue?vue&type=template&id=b7280840&scoped=true&"
import script from "./ServiceIndex.vue?vue&type=script&lang=js&"
export * from "./ServiceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7280840",
  null
  
)

export default component.exports